export enum MarketingConsentType {
  OPTIN = 'OPTIN',
  NOCHANGE = 'NOCHANGE',
}

export const WAITLIST_EMAIL_SUBMITTED = 'waitlist-email-submitted'
export const NUTRITION_NEWSLETTER_EMAIL_SUBMITTED = 'nutrition-newsletter-email-submitted'
export const EMAIL_CAPTURE_CMS_EMAIL_SUBMITTED = 'email-capture-cms-email-submitted'
export const FREEGUIDE_EMAIL_SUBMITTED = 'freeguide-email-submitted'
export const GUTSHOT_EMAIL_SUBMITTED = 'gutshot-email-submitted'
export const WHITEPAPER_EMAIL_SUBMITTED = 'whitepaper-email-submitted'
export const D30_GB_NO_STOCK_WAITLIST_EMAIL_SUBMITTED = 'd30-gb-no-stock-waitlist-email-submitted'
export const D30_US_NO_STOCK_WAITLIST_EMAIL_SUBMITTED = 'd30-us-no-stock-waitlist-email-submitted'
const D30_NON_GB_WAITLIST_EMAIL_SUBMITTED = 'd30-non-gb-waitlist-email-submitted'
export const D30_NON_PURCHASE_COUNTRY_WAITLIST_EMAIL_SUBMITTED = 'd30-non-purchase-country-waitlist-email-submitted'
export const ZOE_CLASSIC_GB_NO_STOCK_WAITLIST_EMAIL_SUBMITTED = 'zoe-classic-gb-waitlist-email-submitted'
export const ZOE_CLASSIC_US_NO_STOCK_WAITLIST_EMAIL_SUBMITTED = 'zoe-classic-us-waitlist-email-submitted'
export const ZOE_CLASSIC_NON_PURCHASE_COUNTRY_WAITLIST_EMAIL_SUBMITTED =
  'zoe-classic-non-purchase-country-waitlist-email-submitted'
export const DAILY30_CHECKOUT_EMAIL_ENTERED = 'd30-checkout-email-entered'
export const DAILY30_CHECKOUT_ADDRESS_CONFIRMED = 'd30-checkout-address-confirmed'
// Abandoned-cart checkout-started signal, now fired client-side on email entry; matches crm-service's `checkout-start` Braze event.
export const CHECKOUT_START = 'checkout-start'
export const CUSTOM_ATTRIBUTE_SENT = 'custom-attribute-sent'

export type BrazeCustomEventName =
  | typeof WAITLIST_EMAIL_SUBMITTED
  | typeof NUTRITION_NEWSLETTER_EMAIL_SUBMITTED
  | typeof FREEGUIDE_EMAIL_SUBMITTED
  | typeof GUTSHOT_EMAIL_SUBMITTED
  | typeof WHITEPAPER_EMAIL_SUBMITTED
  | typeof D30_GB_NO_STOCK_WAITLIST_EMAIL_SUBMITTED
  | typeof D30_US_NO_STOCK_WAITLIST_EMAIL_SUBMITTED
  | typeof D30_NON_GB_WAITLIST_EMAIL_SUBMITTED
  | typeof D30_NON_PURCHASE_COUNTRY_WAITLIST_EMAIL_SUBMITTED
  | typeof ZOE_CLASSIC_GB_NO_STOCK_WAITLIST_EMAIL_SUBMITTED
  | typeof ZOE_CLASSIC_US_NO_STOCK_WAITLIST_EMAIL_SUBMITTED
  | typeof ZOE_CLASSIC_NON_PURCHASE_COUNTRY_WAITLIST_EMAIL_SUBMITTED
  | typeof DAILY30_CHECKOUT_EMAIL_ENTERED
  | typeof DAILY30_CHECKOUT_ADDRESS_CONFIRMED
  | typeof EMAIL_CAPTURE_CMS_EMAIL_SUBMITTED
  | typeof CHECKOUT_START
  | typeof CUSTOM_ATTRIBUTE_SENT
export type BrazeRegisterUserAdditionalFields = {
  firstName?: string
  lastName?: string
  country?: string
  quizUserId?: string
  externalAds?: boolean
}
